<template>
  <div>
    <div class="user-login bg">
      <div id="bg">
        <vue-particles
          color="#dedede"
          :particleOpacity="0.7"
          :particlesNumber="80"
          shapeType="circle"
          :particleSize="4"
          linesColor="#dedede"
          :linesWidth="1"
          :lineLinked="true"
          :lineOpacity="0.4"
          :linesDistance="150"
          :moveSpeed="3"
          :hoverEffect="true"
          hoverMode="grab"
          :clickEffect="true"
          clickMode="push"
        >
        </vue-particles>
      </div>
      <div class="banner">
        <img src="../assets/img/leemma_logo.png" class="leemma_logo" alt="">
        <span>成都利马高科有限公司</span>
      </div>
      <div class="login-content">
        <h1>为传统设备制造商提供工业4.0升级方案</h1>
        <div v-if="cardType==='login'" class="login">
          <div class="login-header">
            <div class="login-header-img">
              <img src="../assets/img/leemma_logo.png" class="leemma_logo" alt="">
            </div>
            <span>欢迎进入利马后台系统</span>
          </div>
          <div class="login-form">
            <form>
              <div class="form-group">
                <label>邮箱</label>
                <input type="email" v-model="user.email" class="form-control"
                       aria-describedby="emailHelp" placeholder="邮箱">

              </div>
              <div class="form-group">
                <label>密码</label>
                <input type="password" @ v-model="user.password" class="form-control"
                       placeholder="密码">
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="checkbox" class="form-check-input">
                  记住密码
                </label>
              </div>
              <button type="button" @click="login" class="btn btn-primary">登陆系统</button>
              <button type="button" @click="goTOWx" class="btn btn-primary wx-button"><i class="iconfont icon-wx "></i>微信登陆
              </button>

            </form>
          </div>
        </div>
        <div v-if="cardType==='verify-code'" class="login" id="verify-code">
          <div class="login-header">
            <h2>账号验证</h2>
          </div>
          <div class="login-form auth-from-box">
            <div>
              <div class="form-group">
                <label for="code">请输入企业验证码</label>
                <input v-model="user.companyCode" type="text" class="form-control" id="code" placeholder="验证码">
              </div>
              <button @click="bindCompany" type="button" class="btn btn-post btn-primary">确定</button>
              <button @click="cardType='login'" role="button" class="btn btn-link">返回首页</button>

            </div>
          </div>
          <div class="water-mark">
            copyright © 2013 成都利马高科有限公司 川ICP备09000473号
          </div>

        </div>
        <div v-if="cardType==='post-phone'" class="login" id="post-phone">
          <div class="login-header">
            <h2>验证失败</h2>
          </div>
          <div class="login-form auth-from-box">
            <p>您的验证码无效，如需帮助请提交您的联系方式，我们的客服将联系您。</p>
            <div>
              <div class="form-group">
                <label for="phone">请输入联系方式</label>
                <input v-model="user.contact" type="text" class="form-control" id="phone" placeholder="">
              </div>
              <button @click="postContact" type="button" class="btn btn-primary btn-post">确定</button>
              <a href="/leemmaLogin"  role="button" class="btn btn-link">返回首页</a>
            </div>
          </div>
          <div class="water-mark">
            copyright © 2013 成都利马高科有限公司 川ICP备09000473号
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// const particles= require('particles.js');
// import particles from 'particles.js';
import { mapActions } from "vuex";

export default {
  name: "leemmaLogin",
  data() {
    return {
      cardType: "login",
      user: {
        email: "",
        password: "",
        companyCode: "",
        token: "",
        contact:""
      }
    };
  },
  created() {
    this.initAccount();
  },
  mounted() {},
  methods: {
    ...mapActions(["updataAccount"]),
    login() {
      let url = "user_sessions/create",
        params = {
          email: this.user.email,
          password: this.user.password
        };
      this.$http.post(url, params).then(res => {
        if (res.status_code === "SUCCEEDED") {
          this.checkToken(res.payload.auth_token);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    checkToken(token) {
      let url = "user/verify",
        params = {
          auth_token: token
        },
        pageUrl;
      this.$http.get(url, { params }).then(res => {
        if (res.status_code === "SUCCEEDED") {
            this.user.token = token;
          if (res.payload.company_id) {
            this.updataAccount({ ...res.payload, auth_token: token });
            switch (this.$route.query) {
              case "devices":
                pageUrl = "/devices";
                break;
              case "new_devices":
                pageUrl = "/devices/new";
                break;
              case "new_customer":
                pageUrl = "/customers";
                break;
              default:
                pageUrl = "/";
            }
            this.$router.push("/leemma" + pageUrl);
          } else {
            debugger;
            // 用户未绑定设备供应商
            this.cardType = "verify-code";
          }
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    goTOWx() {
      let redirect_url = "https://services.leemma.com";
      location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wx64554769b588ff68&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_login&state=leemmaLogin#wechat_redirect`;
    },
    initAccount() {
      let account = JSON.parse(localStorage.getItem("account"));
      let token = account ? account.auth_token : "";
      if (token) {
        this.checkToken(token);
      } else {
        this.checkWechatUA();
      }
    },
    //绑定设备供应商
    bindCompany() {
      let url = "users/verify",
        params = {
          code: this.user.companyCode,
          auth_token: this.user.token
        };
      this.$http.post(url, params).then(data => {
        debugger
        if(data.status_code==='SUCCEEDED'){
          this.$message.success('操作成功')
          this.checkToken(params.auth_token)

        }else{
          this.$message.error(data.msg)
          this.cardType='post-phone'
        }

      });
    },
    //绑定失败后填写联系方式
    postContact(){
      let url ='users/contact',
      params= {
        auth_token: this.user.token,
        contact: this.user.contact
      };
      this.$http.post(url,params).then(data=>{
        if(data.status_code==='SUCCEEDED'){
          this.$message.success("提交成功")
        }else{
          this.$message.error('服务器繁忙，请稍后再试')
        }
      })
    },
    checkWechatUA() {
      let ua = window.navigator.userAgent.toLowerCase(),
        urlParams = this.$route.query,
        appid = "wx64e8514ac107ac11",
        url = "https://services.leemma.com";
      //判断微信浏览器ua.match('micromessenger')
      console.log(ua);

      if (ua.match("micromessenger")) {
        console.log("wx");
        debugger;
        if (urlParams.code) {
          let url = "wechat_authorize/userinfo",
            params = {
              code: urlParams.code,
              type: "user"
            };
          this.$http.get("wechat_authorize/userinfo", { params }).then(data => {
            if (data.status_code === "SUCCEEDED") {
              this.checkToken(data.payload.auth_token);
            } else {
              this.$message.error("微信登陆失败，" + data.msg);
            }
            console.log(data);
          });
        } else {
          console.log(urlParams);
          let hrefUrl,
            state =
              urlParams.url && urlParams.url !== "undefined"
                ? urlParams.url
                : "";
          hrefUrl =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            url +
            "&response_type=code&scope=snsapi_userinfo&state=" +
            state +
            "#wechat_redirect";
          location.href = hrefUrl;
        }
      } else {
        let params = {
          code: urlParams.code,
          type: "user"
        };
        if (urlParams.code) {
          this.$http.get("wechat_login/userinfo", { params }).then(data => {
            if (data.status_code === "SUCCEEDED") {
              this.checkToken(data.payload.auth_token);
            } else {
              this.$message.error("微信登陆失败，" + data.msg);
            }
            console.log(data);
          });
        }
      }
    }
  }
};
</script>

<style type="scss" scoped>
.user-login {
  background: #1f2037;
  min-height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
}

#bg {
  position: absolute;
  width: 99%;
  height: 99%;
}

#particles-js {
  height: 100%;
}

.banner {
  background: #333b54;
  height: 60px;
  line-height: 60px;
  display: flex;
  z-index: 9;
}

.banner img {
  height: 60px;
  margin: 0 60px;
}

.banner > span {
  font-size: 24px;
}

.login-content > h1 {
  color: #ffffff;
  margin: 100px auto;
  text-align: center;
}

.login-content {
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 750px;
}

.login {
  margin: 0 auto;
  background: #343c55;
  width: 28%;
  min-width: 550px;
  height: auto;
  padding: 15px;
}

.login-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.login-header .login-header-img {
  width: 40%;
  height: 90px;
}

.login-header img {
  width: 100%;
}

.login-form {
  width: 80%;
  margin: 35px auto;
}

.login-form .btn {
  width: 100%;
  margin: 10px 0;
}

.water-mark {
  color: #ffffff;
  width: 420px;
  position: absolute;
  bottom: 10px;
  left: 50%;
  margin-left: -210px;
  text-align: center;
}



.wx-button {
  background: #62b900;
  text-indent: -33px;
}

.wx-button .iconfont {
  margin: 0 8px;
}

@media screen and (max-width: 996px) {
  .login-content > h1,
  .banner,
  .water-mark {
    display: none;
  }
  .login {
    min-width: 100%;
    background: none;
  }
  .login-form {
    margin: auto;
  }
  .auth-from-box .input {
    width: 100%;
  }
  .auth-from-box .form-inputs .form-group {
    max-width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/leemmaLogin.vue